(() => {
  const root = document.querySelector('[data-email-offer]');
  if (!root || !window.HTMLDialogElement) return;

  const dialog = root.querySelector('[data-email-offer-dialog]');
  const teaser = root.querySelector('[data-email-offer-open]');
  const emailInput = root.querySelector('#LqEmailOfferInput');
  const success = root.querySelector('[data-email-offer-success]');
  const dismissKey = 'lq-email-offer-dismissed-at';
  const subscribedKey = 'lq-email-offer-subscribed';
  const dismissDuration = 14 * 24 * 60 * 60 * 1000;
  let trigger = null;
  let readyAfterDelay = false;
  let reachedScrollThreshold = false;

  const getStored = (key) => {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  };

  const setStored = (key, value) => {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      // The offer remains usable when storage is unavailable.
    }
  };

  const isRecentlyDismissed = () => {
    const dismissedAt = Number(getStored(dismissKey));
    return Number.isFinite(dismissedAt) && Date.now() - dismissedAt < dismissDuration;
  };

  const hasSubscribed = () => getStored(subscribedKey) === 'true';

  const showTeaser = () => {
    if (!hasSubscribed() && !dialog.open) teaser.hidden = false;
  };

  const openDialog = (source, force = false) => {
    if (dialog.open || (hasSubscribed() && !force)) return;
    trigger = source instanceof HTMLElement ? source : null;
    teaser.hidden = true;
    dialog.showModal();
    window.requestAnimationFrame(() => {
      (emailInput || success || dialog).focus();
    });
  };

  const closeDialog = () => {
    if (!dialog.open) return;
    dialog.close();
  };

  const markDismissed = () => {
    if (!hasSubscribed()) setStored(dismissKey, String(Date.now()));
  };

  const tryTimedOpen = () => {
    if (readyAfterDelay && reachedScrollThreshold && !isRecentlyDismissed()) openDialog(null);
  };

  if (success) {
    setStored(subscribedKey, 'true');
    window.requestAnimationFrame(() => openDialog(null, true));
  } else if (!hasSubscribed()) {
    showTeaser();
    window.setTimeout(() => {
      readyAfterDelay = true;
      tryTimedOpen();
    }, window.matchMedia('(max-width: 749px)').matches ? 12000 : 8000);

    const updateScrollThreshold = () => {
      const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
      reachedScrollThreshold = scrollableHeight <= 0 || window.scrollY >= scrollableHeight * 0.2;
      tryTimedOpen();
    };

    window.addEventListener('scroll', updateScrollThreshold, { passive: true });
    updateScrollThreshold();

    if (!window.matchMedia('(max-width: 749px)').matches) {
      document.addEventListener('mouseout', (event) => {
        if (event.relatedTarget || event.clientY > 0 || isRecentlyDismissed()) return;
        openDialog(null);
      });
    }
  }

  teaser.addEventListener('click', () => openDialog(teaser));
  root.querySelectorAll('[data-email-offer-close]').forEach((button) => {
    button.addEventListener('click', closeDialog);
  });

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) closeDialog();
  });

  dialog.addEventListener('cancel', markDismissed);
  dialog.addEventListener('close', () => {
    if (!success) markDismissed();
    showTeaser();
    if (trigger) trigger.focus();
  });
})();
